import "helpers/initFA";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Main from "./Main";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container = document.getElementById("main");
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Main>
        <App />
      </Main>
    </QueryClientProvider>
  </React.StrictMode>
);
